import type { RouteRecordRaw } from 'vue-router'
const entity = "DC_SYS_MODULE"
const routers: RouteRecordRaw = {
  path: '/sys-module',
  name:'sys-module',
  meta: {
    title: '系统模块管理'
  },
  children: [
    {
      path: 'list',
      name: 'sys-module-list',
      meta: {
        title: '系统模块列表'
      },
      props:{
        entity:entity,
      },
      component: ()=>{return import("../../views/dynamic-form/DynamicTreeListView.vue")}
    }
  ]
}
export default routers
